/**
 * UI控件库 
 * @module UI
 */

;(function (ui,$) {
    "use strict";
    /**
     * <h3>弹出框</h3>
     * <a href="../../ui_controls/bui.dialog.html" target="_blank">demo</a><br>
     * {{#crossLink "bui.dialog/option"}}{{/crossLink}}: 获取设置参数 <br>
     * {{#crossLink "bui.dialog/widget"}}{{/crossLink}}: 获取依赖控件 <br>
     * {{#crossLink "bui.dialog/open"}}{{/crossLink}}: 打开弹出窗 <br>
     * {{#crossLink "bui.dialog/close"}}{{/crossLink}}: 关闭弹出窗 <br>
     * {{#crossLink "bui.dialog/remove"}}{{/crossLink}}: 移除弹出窗 <br>
     * {{#crossLink "bui.dialog/create"}}{{/crossLink}}: 动态创建弹出窗<br>
     *  @namespace bui
     *  @class dialog
     *  @requires mask toggle
     *  @constructor 
     *  @param {object} option  
     *  @param {string} [option.id] [ render:true 不需要传对话框的id | render:false 为静态绑定]  
     *  @param {string} [option.effect] [对话框的打开效果,具体可以查看bui.toggle有哪些效果]  
     *  @param {string} [option.position] [ 对话框的位置 默认 center | left | right | top | bottom ]  
     *  @param {string} [option.width] [ 对话框的宽度, 只在 position:center | left | right 有效 ]  
     *  @param {string} [option.height] [ 对话框的高度, 只在 position:center | top | bottom 有效 ]  
     *  @param {boolean} [option.fullscreen] [ 全屏显示对话框 ]  
     *  @param {boolean} [option.scroll] [ true | false 是否计算最大高度,配合height参数,超出可以滚动 ]  
     *  @param {boolean} [option.mask] [是否显示遮罩]  
     *  @param {number} [option.opacity] [ 遮罩的透明度 ]  
     *  @param {boolean} [option.zoom] [ 保持比例缩放 默认 false | true ]   
     *  @param {function} [option.callback] [ 点击按钮的回调, this 指点击的按钮 ]  
     *  @param {function} [option.onMask] [ 点击遮罩的回调 ]  
     *  @param {function} [option.onClose] [ 对话框关闭的回调 ]  
     *  
     *  @param {boolean} [option.render] [ 是否动态填充,动态填充以下参数才会有效 ]  
     *  @param {string} [option.title] [ render:true 对话框的标题才会显示 ]  
     *  @param {string} [option.content] [ render:true 对话框的内容]  
     *  @param {boolean} [option.close] [ render:true 显示关闭文本 ]  
     *  @param {string|html} [option.closeText] [ render:true 才能把图标改为文本并且可以更改图标 ]  
     *  @param {boolean} [option.autoClose] [ render:true true点击按钮会自动关闭,如果false需要手动关闭 调用自身的close()方法]  
     *  @param {array} [option.buttons] [ render:true 底部的按钮 格式为:["确定","取消"] || [{name:"确定",className:"primary"}] ]  
     *  
     *  @example
     * 
     *  html: 
     *
            //对话框的标准结构
            <div id="dialog" class="bui-dialog" style="display:none;">
                <div class="bui-dialog-head">对话框标题</div>
                <div class="bui-dialog-main">对话框的内容</div>
            </div>
     *  js: 
      
        var uiDialog = bui.dialog({
              id: "#dialog"
            });
     *
     */
    ui.dialog = function(option){
    	var config = {
    		id: "",
    		title: "",			
            effect: "fadeInDown",
    		content: "",	
            position:"center", 
            fullscreen: false,
            width: 0,
            height: 0,
            mask: true,    
            opacity: 0.1,
            render: false,    
            autoClose: true,
            close: true,      
            scroll: true,
            closeText: "",
            zoom : false,
            buttons: [],
            onMask: null,
            onClose: null,
    		callback: null
    	};

        //方法
        var module = {
            open: open,
            close: close,
            isOpen: isOpen,
            create: create,
            remove: remove,
            widget: widget,
            option: options,
            config: param,
            init: init
        };
        //用于option方法的设置参数
        var param = module.config = $.extend(false, {},config, ui.config.dialog, option );
    	
    	var $id,
    		uiToggle,
            cssName = "",
            dialogWidth = "",
            dialogHeight = "",
            effect,
            status = 0, //中间高度自适应
            isOpen = false,
    		mask,
    		count = 0;

        if( param.id ){
            //初始化
            init(param);
        }
    	

    	function init (option) {
            option = option || param;
            
            effect = option.effect;

            //自定义效果跟位置有关
            switch( option.position ){
                case "top":
                cssName = "bui-dialog-top";
                effect = "fadeInDown";
                break;
                case "bottom":
                cssName = "bui-dialog-bottom";
                effect = "fadeInUp";

                break;
                case "left":
                cssName = "bui-dialog-left";
                effect = "fadeInLeft";

                break;
                case "right":
                cssName = "bui-dialog-right";
                effect = "fadeInRight";

                break;
                case "center":
                cssName = "bui-dialog-center";
                effect = option.effect;

                break;
            }

            //是否全屏
            if( option.fullscreen ){
                cssName = "bui-dialog-fullscreen";
                effect = option.effect;
            }

            //动态渲染,无需传id,会生成guid
            if( option.render ){

                option.id = ui.guid();

                render(option);

                $id = ui.obj(option.id);

            }else{

                if( option.id ){
                    $id = ui.obj(option.id);

                    $id.addClass(cssName);
                }else{
                    ui.hint("dialog id不能为空");

                    return;
                }
            }

            //默认先隐藏dialog
            $id.css("display","none");
            //初始化dialog切换器,显示隐藏基于这个控件
            uiToggle = ui.toggle({
                id: option.id,
                effect: effect
            });

            //option获取新参数使用
            param = module.config = option;

    		return this;
    	}


    	//动态渲染模板
    	function template (option) {

    		var html = '';

    			// 这里的 option.id 是动态生成的guid,在callback中可以拿到
    			html += '<div id="'+option.id+'" class="bui-dialog '+cssName+'" style="display:block">';
    			if( option.title ){
					html += '	<div class="bui-dialog-head">'+option.title+'</div>';
    			}
				html += '	<div class="bui-dialog-main">';
				if( option.content ){
					html += option.content;
				}
				html += '	</div>';
				if( option.buttons.length ){
					html += '	<div class="bui-dialog-foot bui-box">';
					$(option.buttons).each(function (i,item) {
						html += '		<div class="bui-btn span1 '+(item.className || '')+'" value="'+(item.value || '')+'">'+(item.name || item)+'</div>';
					})
					html += '	</div>';
				}
				//是否显示关闭按钮
				if( option.close  ){
                    html += '   <div class="bui-dialog-close">'+ (option.closeText ? option.closeText: '<i class="icon-close"></i>' )+'</div>';
				}
				html += '</div>';

			return html;
    	}

    	/**
         * 打开对话框
         *  @method open
         *  @chainable
         *  @param {function} [callback] [回调]
         *  @example 

            uiDialog.open();
                
         */
    	function open (callback) {

            $id.css("display","block");

            var status = ( $id.attr("status") || 0 );

            //通过状态判断,不用每次都重新计算高度
            if( status == 0 ){

                dialogWidth = param.width || $id.width();
                dialogHeight = param.height || $id.height();

                var dialogRemWidth = ui.unit.pxToRemZoom(dialogWidth),
                    dialogRemHeight = ui.unit.pxToRemZoom(dialogHeight);

                // 是否采用等比缩放
                var dialogWidthValue = param.zoom ? dialogRemWidth+'rem' : dialogWidth+'px',
                    dialogHeightValue = param.zoom ? dialogRemHeight+'rem' : dialogHeight+'px',
                    dialogTopValue = param.zoom ? '-'+dialogRemHeight/2+'rem' : '-'+dialogHeight/2+'px',
                    dialogLeftValue = param.zoom ? '-'+dialogRemWidth/2+'rem' : '-'+dialogWidth/2+'px';

                //不是全屏 center 才有效
                if( param.position == "center" && !param.fullscreen){

                    $id.css({
                        "width": dialogWidthValue,
                        "height": dialogHeightValue,
                        "top":"50%",
                        "margin-top": dialogTopValue,
                        "left":"50%",
                        "margin-left": dialogLeftValue,
                        "right":"auto"
                    })
                }
                //左右的时候有宽度就设置宽度
                if( (param.position == "left" || param.position == "right") && !param.fullscreen){

                    $id.css({
                        "width": dialogWidthValue
                    })
                }
                if( (param.position == "top" || param.position == "bottom") && !param.fullscreen){

                    $id.css({
                        "height": dialogHeightValue
                    })
                }

                // 如果需要超出滚动条,则设置scroll还有高度
                if ( param.scroll ){
                    var $dialogHead = $id.children('.bui-dialog-head'),
                        $dialogFoot = $id.children('.bui-dialog-foot'),
                        $dialogMain = $id.children('.bui-dialog-main');
                    var headHeight = $dialogHead.length ? ($dialogHead.height() < 40 ? 40 :$dialogHead.height() ) : 0 ,
                        footHeight = $dialogFoot.length ? ($dialogFoot.height() ) : 0 ,
                        headRemHeight = ui.unit.pxToRemZoom(headHeight) ,
                        footRemHeight = ui.unit.pxToRem(footHeight) ,
                        mainHeight = dialogHeight - headHeight  - footHeight ,
                        mainRemHeight = ui.unit.pxToRemZoom(mainHeight) ;

                    var mainHeightValue = param.zoom ? mainRemHeight+'rem' : mainHeight+'px',
                        headHeightValue = param.zoom ? headRemHeight+'rem' : headHeight+'px',
                        footHeightValue = param.zoom ? footRemHeight+'rem' : footHeight+'px';

                    $dialogMain.css({
                        "height": mainHeightValue
                    });
                    $dialogHead.css({
                        "height": headHeightValue
                    });
                    
                }

                $id.attr("status","1");
            }
            
    		//引用动画控制器
            uiToggle.show(function (argument) {
                isOpen = true;
                callback && callback(module, uiToggle );

            });

    		//显示遮罩
    		if( param.mask ){
    			mask = ui.mask({
                    opacity: param.opacity,
                    callback: function(argument) {
                        param.onMask && param.onMask();
                    }
                });

    		}

            //绑定事件
            bind();
    		return this;
    	}

        /**
         * 检测窗口是否打开
         *  @method isOpen
         *  @example 

            var status = uiDialog.isOpen();
                
         */
        function isOpen(argument) {
            return isOpen;
        }
        /**
         * 关闭对话框
         *  @method close
         *  @chainable
         *  @param {function} [callback] [回调]
         *  @example 

            uiDialog.close();
                
         */
    	function close (callback) {

            var callback = callback || param.onClose ;
            try{
	    		uiToggle.hide(function (argument) {

                    isOpen = false;
                    callback && callback.call(module, uiToggle );

                });


	    		if( mask ){
	    			//移除遮罩
	    			mask.remove();
	    		}
            
            }catch(e){};
	    	
    		return this;
    	}

        /**
         * 移除对话框
         *  @method remove
         *  @chainable
         *  @example 

            uiDialog.remove();
                
         */
        function remove () {
            try{

                $id.remove();

                if( mask ){

                    //移除遮罩
                    mask.remove();

                    //解决ios8 遮罩可以滚动问题
                    $("main").css({
                        "overflow-y":"auto"
                    });
                }
            }catch(e){};

            return this;
        }

    	//渲染模板
    	function render (option) {
    		//生成模板
    		var html = template(option);
    		
    		$("body").append(html);

    		return this;
    	}

    	//绑定关闭及底部按钮事件
    	function bind () {
    		//绑定关闭事件
			$id.off('click.bui',".bui-dialog-close").on('click.bui',".bui-dialog-close", function(event) {
                
                //执行回调
                param.callback && param.callback.call(this,module);

                //如果autoClose=true 并且是动态渲染,则关闭移除
                if( param.autoClose ){
                    if( param.render ){
                        close(remove);
                    }else{
                        close();
                    }
                }

                event.stopPropagation();
			});
    		//点击底部的按钮
			$id.off('click.bui',".bui-dialog-foot .bui-btn").on('click.bui',".bui-dialog-foot .bui-btn", function(event) {

				//执行回调
				param.callback && param.callback.call(this,module);
				
                //如果autoClose=true 并且是动态渲染,则关闭移除
                if( param.autoClose ){
                    if( param.render ){
                        close(remove);
                    }else{
                        close();
                    }
                }
                event.stopPropagation();

			});

    		return this;
    	}

        /**
         * 动态增加对话框
         *  @method create
         *  @param {object} option [参考{{#crossLink "bui.dialog"}}{{/crossLink}} 的参数]
         *  @chainable
         *  @example 

            uiDialog.create({ content:"提醒内容", title:"标题"}).open();
                
         */
    	function create (option) {

            config.title = "提示";
            config.content = "";
            config.close = false;
            config.render = true;
            config.autoClose = true;
            config.mask = true;
            config.buttons = ["确定"];
            
            param = $.extend(true,  config, option );

    		init(param);

    		return this;
    	}
        
        /**
         * 获取依赖的控件 
         *  @method widget
         *  @param {string} [name] [ 依赖 toggle 控件]
         *  @example 
            
            //获取依赖控件
            var uiDialogWidget = uiDialog.widget("toggle");
                
         */
        function widget(name) {
            var control = { toggle: uiToggle };
            return ui.widget.call(control,name);
        };

        /**
         * 获取设置参数
         *  @method option
         *  @param { string | object } [key] [ 不传则获取所有参数, 类型为string,没有第2个参数则获取某个参数 ]
         *  @param { string | number | boolean | function } [value] [ 设置参数的时候要传,设置多个参数不用传,获取参数的时候也不用传 ]
         *  @chainable
         *  @example 
            
            
            //获取所有参数
             //获取所有参数
            var option = uiDialog.option();

            //获取某个参数
            var id = uiDialog.option( "id" );

            //修改一个参数
            uiDialog.option( "fullscreen",true );

            //修改多个参数
            uiDialog.option( {"fullscreen":true} );
                
         */
        function options (key,value) {

           return ui.option.call(module,key,value);
        }


        return module;
    };


/*
 * 常用消息提醒 基于 dialog 扩展
 * -------------------------------------------------------
 */

    /**
     *  提醒框,可以提醒json, 更多参数请参考 {{#crossLink "bui.dialog"}}{{/crossLink}}
     *  @namespace bui
     *  @class alert
     *  @extends bui.dialog
     *  @constructor 
     *  @param {string} text [提醒的文本 ]
     *  @param {function} [callback] [点击回调  this 指点击的按钮]
     *  @example
     * 
            bui.alert("提醒对话框")
     *
     */
    ui.alert = function (text,callback) {

        var uiDialog= ui.dialog();
        var config = {};
            config.title = "提示";
            config.width = 400;
            config.height = 240;
            config.scroll = true;
            config.position = "center";
            config.autoClose = true;
            config.zoom = true;
            config.callback = callback || function(){};

        var param = $.extend( config, ui.config.alert );

        //html标签
        if( typeof text == "string" && text.indexOf('<') > -1 && text.indexOf('>') > -1 ){
            param.content = "<xmp>"+text +"</xmp>";

        }else if( typeof text == "object"){
            
            var str = JSON.stringify(text);

            param.content = '<div class="bui-dialog-text bui-box-center" style="height:100%;">'+str+'</div>';
                
        }else {
            var str = text;

            param.content = '<div class="bui-dialog-text bui-box-center" style="height:100%;">'+str+'</div>';
                
        }

        uiDialog.create(param).open();

        return uiDialog;

    };

    /**
     *  确定提醒框,基于dialog 更多参数请参考 {{#crossLink "bui.dialog"}}{{/crossLink}}
     *  @namespace bui
     *  @class confirm
     *  @extends bui.dialog
     *  @constructor 
     *  @param {string} text [提醒的文本 ]
     *  @param {function} [callback] [点击回调  this 指点击的按钮]
     *  @example
     * 
    方法1, 确认提醒:
     *        
            bui.confirm("确定会删除信息,不可还原",function(){
    
           })
    方法2 可以修改更多参数: 
     * 
            bui.confirm({ 
                content:"确定会删除信息,不可还原",
                title:"修改了标题",
                buttons:["取消","确定"],
                callback:function(){
                    var text = $(this).text();
                    if( text == "确定"){
                        // do something
                    }
                    console.log(this);
                }
            })
     *
     */
    ui.confirm = function (option, callback) {

        var uiDialog= ui.dialog();
        var config = {};
            config.title = "提示";
            config.width = 400;
            config.height = 240;
            config.scroll = true;
            config.autoClose = true;
            config.zoom = true;
            config.position = "center";
            config.buttons = ["取消","确定"];
            config.callback = callback || function(){};

        var param = {};
        if( typeof option === "object"){
            option.content = '<div class="bui-dialog-text bui-box-center" style="height:100%;">'+option.content+'</div>';
            
            param = $.extend( config, ui.config.confirm, option );

        }else{
            
            param = $.extend( config, ui.config.confirm );

            param.content = '<div class="bui-dialog-text bui-box-center" style="height:100%;">'+option+'</div>';
            param.callback = callback || function(){};

        }
        
        uiDialog.create(param).open();

        return uiDialog;
    }

    return ui;

})( bui || {}, libs );
